angular
    .module('app')
    .component('groupsEdit', {
        templateUrl: '/templates/pages/groups/groupsEdit/groupsEdit.html',
        controller: 'GroupEditController',
        controllerAs: 'vm',
    });